/* @flow */

import React, { Component } from 'react';
import { Button, Modal, Header, Card } from 'semantic-ui-react';
import BlockTypeCard from './BlockTypeCard';

type Props = {
  templates: Array<EditorialBlockTemplate>,
  onAdd: (type: EditorialBlockType) => void,
};

type State = {
  displayModal: boolean,
};

class AddBlockButton extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      displayModal: false,
    };
  }

  showModal = () => this.setState({ displayModal: true });
  hideModal = () => this.setState({ displayModal: false });

  addBlock = (type: EditorialBlockType) => {
    this.props.onAdd(type);
    this.hideModal();
  };

  render() {
    const { templates } = this.props;

    return (
      <div>
        <Modal basic open={this.state.displayModal} onClose={this.hideModal}>
          <Header content="Ajouter un contenu" />
          <Card.Group itemsPerRow={3}>
            {templates.map(bt => (
              <BlockTypeCard
                key={bt.code}
                template={bt}
                onSelect={this.addBlock}
              />
            ))}
          </Card.Group>
        </Modal>
        <Button
          type="button"
          onClick={this.showModal}
          icon="add"
          content="Ajouter"
          labelPosition="right"
        />
      </div>
    );
  }
}

export default AddBlockButton;



// WEBPACK FOOTER //
// ./src/modules/edito/components/AddBlockButton.js